import React from 'react';
import PropTypes from 'prop-types';
import StyledTitle from '../../hoc/StyledTitle';
import ToolTip from '../AssetPropertyView';

@StyledTitle
class Span extends React.Component {

  static propTypes = {
    children: PropTypes.any
  }

  render() {
    const { children, title,...props } = this.props;
    return (
      <span name="Span" {...props}>
        <ToolTip text={title} style={{display: 'inline'}}>
        {children}
        </ToolTip>
        </span>
    );
  }

}

export default Span;
